import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainSideBarComponent } from './main-side-bar/main-side-bar.component';



@NgModule({
  declarations: [
    MainSideBarComponent
  ],
  imports: [
    CommonModule
  ],exports :[
    MainSideBarComponent
  ]
})
export class MainSideBarModule { }
